module.exports = __webpack_public_path__ + "files/d1e93753b030f8ee017415ccf96d95f4.png";